import React, { useEffect } from "react"
import withRouter from "components/Common/withRouter"
import Header from "./Header"
import Sidebar from "./Sidebar"

//redux
import { useSelector, useDispatch } from "react-redux"

const Layout = (props) => {
  const dispatch = useDispatch()

  const { leftSideBarType, leftSideBarTheme } = useSelector(
    (state) => state.layout
  )

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  const toggleMenuCallback = () => {
    if (leftSideBarType === "default") {
      dispatch(changeSidebarType("condensed", isMobile))
    } else if (leftSideBarType === "condensed") {
      dispatch(changeSidebarType("default", isMobile))
    }
  }

  //hides right sidebar on body click
  const hideRightbar = (event) => {
    var rightbar = document.getElementById("right-bar")
    //if clicked in inside right bar, then do nothing
    if (rightbar && rightbar.contains(event.target)) {
      return
    } else {
    }
  }

  /*
  layout  settings
  */

  useEffect(() => {
    //init body click event fot toggle rightbar
    document.body.addEventListener("click", hideRightbar, true)
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <React.Fragment>
      <div
        id="layout-wrapper"
        style={{
          backgroundColor: "#09518c",
          borderRadius: "0px",
          borderTopLeftRadius: "15px",
          borderTopRightRadius: "15px",
          borderBottomRightRadius: "15px",
          borderBottomLeftRadius: "15px",
          height: "94vh",
          overflowX: "hidden",
          position: "relative",
          overflowY: "hidden",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
        }}
        className="hide-scrollbar"
      >
        <Header toggleMenuCallback={toggleMenuCallback} />
        <Sidebar
          theme={leftSideBarTheme}
          type={leftSideBarType}
          isMobile={isMobile}
        />
        <div className="main-content">{props.children}</div>
      </div>
    </React.Fragment>
  )
}

export default withRouter(Layout)
